export default __webpack_public_path__ + "static/media/plane.acfecc08.svg";